module.exports = __webpack_public_path__ + "static/media/twitter-footer.fe7c8fe6.svg";